module.exports = __webpack_public_path__ + "28b67065/img/arrow-left-icon.785c715c.svg";